import { useCallback } from 'react';
import { SHOW_MODAL } from 'Reducers/modal/types';
import i18n from 'Utilities/i18n';
import { store } from 'Utilities/store';

/**
 * This hook displays a modal when there is a failed API Call. This can occur in the case of
 * no internet or an unexpected error or API server being down.
 */
const useApiError = () => {
  const showApiErrorModal = useCallback(() => {
    store.dispatch({
      type: SHOW_MODAL,
      modalProps: {
        details: i18n.t('Global.modals.errorCommunicatingServer.body'),
        testID: 'ApiErrorModal'
      }
    });
  }, []);
  return {
    showApiErrorModal
  };
};
export default useApiError;